import { render, staticRenderFns } from "./alipay_app.vue?vue&type=template&id=0a93b330&scoped=true&"
import script from "./alipay_app.vue?vue&type=script&lang=js&"
export * from "./alipay_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a93b330",
  null
  
)

export default component.exports